<template>
    <div class="pagination">
        <button
			type="button"
			class="pagination__button pagination__button--prev"
			aria-label="Previous Page"
            :disabled="page === 1"
            @click="prevPage"
		><svg xmlns="http://www.w3.org/2000/svg" width="10" height="6" viewBox="0 0 10 6" class="svg-chevron" fill="currentColor"><path  d="m5.00025 5.55261 4.656-4.656-.672-.672-3.984 3.984-3.984-3.984-.672.672 4.656 4.656Z"/></svg></button>
        <button
            type="button"
            class="pagination__button pagination__button--ellipsis"
            :class="{ 'pagination__button--active': currentPage == 1 }"
            :disabled="page == 1"
            @click="setCurrentPage(1)"
            v-if="firstDisplayablePage !== 1"
        >1&hellip;</button>
		<button
			type="button"
			class="pagination__button"
            :class="{ 'pagination__button--active': page == i }"
            v-for="i in displayablePages"
            @click="setCurrentPage(i)"
            :disabled="currentPage == i"
		>{{ i }}</button>
        <button
            type="button"
            class="pagination__button pagination__button--ellipsis"
            :class="{ 'pagination__button--active': page == pages }"
            :disabled="page == pages"
            v-if="lastDisplayablePage !== pages"
            @click="setCurrentPage(lastDisplayablePage)"
        >&hellip;{{ pages }}</button>
		<button
			type="button"
			class="pagination__button pagination__button--next"
			aria-label="Next Page"
            :disabled="currentPage === pages"
            @click="nextPage"
		><svg xmlns="http://www.w3.org/2000/svg" width="10" height="6" viewBox="0 0 10 6" class="svg-chevron" fill="currentColor"><path  d="m5.00025 5.55261 4.656-4.656-.672-.672-3.984 3.984-3.984-3.984-.672.672 4.656 4.656Z"/></svg></button>
    </div>
</template>
<script>
import withBreakpoint from './breakpoints/with-breakpoint.vue';
export default {
    name: 'ComplexPagination',
    mixins: [withBreakpoint],
    props: {
        maxPageButtons: { type: [Object], default: () => ({ phone: 4, tablet: 4, desktop: 4, infinite: 4 }) },
        pages: {
            type: Number,
            default: 0,
        },
        activePage: { type: Number },
        containerSelector: { type: String }
    },
    data: () => ({
        page: 1,
        container: window,
    }),
    computed: {
        breakpoint() {
            return this.currentBreakpoint || 'phone';
        },
        isMobile() {
            return this.breakpoint == 'phone';
        },
        currentPage: {
            get() { return this.page; },
            set(val) {
                this.page = parseInt(val, 10);
                this.setPageParam(val);
            }
        },
        pageStart() {
            return 1;
        },
        pageEnd() {
            return this.pages;
        },
        displayablePages() {
            let displayablePages = [];

            const maxPageButtons = Math.min(this.maxPageButtons[this.breakpoint], this.pages);
            let firstDisplayablePage = this.currentPage - 1;
            let lastDisplayablePage = firstDisplayablePage + maxPageButtons - 1;

            if (firstDisplayablePage < 1) {
                firstDisplayablePage = 1;
                lastDisplayablePage = firstDisplayablePage + maxPageButtons - 1;
            }

            if (lastDisplayablePage > this.pages) {
                lastDisplayablePage = this.pages;
                firstDisplayablePage = (lastDisplayablePage - maxPageButtons + 1);
            }


            for (let i = firstDisplayablePage; i <= lastDisplayablePage; i++) {
                displayablePages.push(i);
            }

            return displayablePages;
        },
        firstDisplayablePage() {
            return this.displayablePages[0];
        },
        lastDisplayablePage() {
            return this.displayablePages[this.displayablePages.length - 1];
        },
    },
    watch: {
        page(val) {
            this.setPageParam(val);
            this.$emit('pagechange', val);
        },
        activePage(val) {
            this.currentPage = val;
        }
    },
    created() {
        this.handleSearchParams();
    },
    mounted() {
        if (this.containerSelector) {
            this.container = document.querySelector(this.containerSelector);
        }
    },
    methods: {
        setCurrentPage(page) {
            this.currentPage = page;
            const header = document.querySelector('.mir__header');
            const superNav = document.querySelector('.main-nav');

            if (header && superNav && this.container) {
                const headerHeroHeight = (header.offsetHeight || 0);
                this.container.scrollTo({
                    top: headerHeroHeight,
                    behavior: 'smooth'
                });
            }
        },
        nextPage() {
            if (this.currentPage < this.pages) {
                this.setCurrentPage(this.currentPage + 1);
            }
        },
        prevPage() {
            if (this.currentPage > 1) {
                this.setCurrentPage(this.currentPage - 1);
            }
        },
        setPageParam(val) {
            const params = new URLSearchParams(location.search);
            if (val > 1) {
                params.set('page', val);
            } else {
                params.delete('page');
            }
            history.replaceState({}, '', `${location.pathname}?${params}`);
        },
        handleSearchParams() {
            const params = new URLSearchParams(location.search);
            if (params.has('page')) {
                this.setCurrentPage(params.get('page'));
            }
        }
    }
};
</script>



// WEBPACK FOOTER //
// resources/components/apps/complex-pagination.vue